import {
  Box,
  Collapse,
  createStyles,
  makeStyles,
  Table,
  TableBody,
  Grid,
  TableRow,
  withWidth,
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import moment from "moment-timezone";
import React from "react";
import { formatCurrency } from "../../../components/Utils/Currency";
import {
  StyledTableCell,
  StyledTableRow,
  StyledTableCellStruct,
} from "../../../components/CustomStyles/CustomTable";
import { css, cx } from "emotion";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      width: "100%",
    },
    paper1: {
      marginTop: 1,
      backgroundColor: theme.palette.background.paper,
    },
    headerPages: {
      fontWeight: 700,
      color: "#212121",
      fontSize: 16,
    },
    description: {
      fontSize: 12,
      marginTop: 25,
      marginLeft: 15,
      position: "absolute",
    },
    positifAmount: {
      color: "#4CAF50",
      fontSize: 16,
      marginTop: 2,
      textAlign: "right",
    },
    negatifAmount: {
      color: "#F44336",
      fontSize: 16,
      marginTop: 2,
      textAlign: "right",
    },
  })
);

const Panel = React.memo(({ transaction }) => {
  const [openRow, setOpenRow] = React.useState(false);
  const order = transaction.orders[0];
  const tenant = order.tenant;

  return (
    <React.Fragment>
      <StyledTableRow>
        <StyledTableCell style={{ color: "#2196F3" }}>
          <input type="checkbox" />
        </StyledTableCell>
        <StyledTableCell style={{ color: "#2196F3" }}>
          <small>{transaction.unique_id}</small>
        </StyledTableCell>
        <StyledTableCell>{tenant.name || ""}</StyledTableCell>
        <StyledTableCell>
          {moment(transaction.create_time)
            .tz(tenant?.property?.timezone)
            .format("DD-MM-YYYY")}
        </StyledTableCell>
        <StyledTableCell style={{ color: "#4CAF50" }}>
          <b>Rp. 150.000</b>
        </StyledTableCell>
      </StyledTableRow>
      <StyledTableRow>
        <StyledTableCell colSpan={7} style={{ padding: 0, border: "none" }}>
          <Collapse
            in={openRow}
            timeout="auto"
            unmountOnExit
            style={{ backgroundColor: "#F5F5F5", padding: 16 }}
          >
            <Box
              margin={0}
              style={{ width: "100%", backgroundColor: "#F5F5F5" }}
            >
              <Table size="small" aria-label="detail order">
                <TableBody>
                  {order.items
                    ? order.items.map((item, i) => {
                        return (
                          <TableRow key={i}>
                            <StyledTableCellStruct
                              style={{
                                border:
                                  order.items.length <= 1
                                    ? "0px solid grey"
                                    : "",
                              }}
                            >
                              <img
                                src={order?.tenant?.logo?.square}
                                alt="logo"
                                style={{ width: 50, height: 50 }}
                              />
                              <span
                                style={{
                                  marginLeft: 15,
                                  color: "#212121",
                                  fontSize: 12,
                                  position: "absolute",
                                }}
                              >
                                Stratus Padded Jacket
                                <br />
                                <small>
                                  Variant: XL, Biru
                                  <br />
                                  x1
                                </small>
                              </span>
                            </StyledTableCellStruct>
                            <StyledTableCellStruct
                              align="right"
                              style={{
                                border:
                                  order.items.length <= 1
                                    ? "0px solid grey"
                                    : "",
                              }}
                            >
                              <b>
                                {formatCurrency(
                                  tenant?.property?.currency,
                                  (
                                    item.qty *
                                    (item.discounted_price
                                      ? item.discounted_price
                                      : item.price.value)
                                  ).toString()
                                )}
                              </b>
                            </StyledTableCellStruct>
                          </TableRow>
                        );
                      })
                    : ""}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </StyledTableCell>
      </StyledTableRow>
    </React.Fragment>
  );
});
const PanelTransaksi = React.memo(({ data }) => {
  return (
    <div className="py-3 bg-white border-bottom-2-secondary" key={data?.id}>
      <div className="w-100 d-flex justify-content-start align-items-start">
        <img
          src={data?.tenant?.logo?.square}
          alt="logo"
          style={{ width: 50, height: 50 }}
        />
        <div className={cx(css`width: 65% !important`,"pl-4 pr-3")}>
          {data?.is_credit &&
            <span className="font-14 font-bold text-primary">
              Pembayaran berhasil diterima
            </span>
          }
          {!data?.is_credit &&
            <span className="font-14 font-bold text-primary">
              Saldo ditarik
            </span>
          }
          
          <p className="font-12 text-primary mt-3">
            {`${data?.remarks}`}
            {data?.history_logs?.map((log, key) => {
              return <span className="d-block" key={key}>{`* ${moment(log?.created_time).tz(data?.tenant?.property?.timezone || "").format("YYYY-MM-DD HH:mm:ss")} : ${log?.status}`}</span>
            })}
          </p>
        </div>
        <div className="ml-auto">
          <div className="d-flex flex-column justify-content-start align-items-end">
            <span className="text-muted font-9">
              Tanggal : <b>{moment(data?.trx_time).tz(data?.tenant?.property?.timezone || "").format("DD MMM YYYY")}</b> | Pukul : <b>{moment(data?.trx_time).tz(data?.tenant?.property?.timezone || "").format("HH:mm")}</b>
            </span>
            {data?.is_credit ? 
              <h4 className={data.cancel ? cx(css`text-decoration: line-through`,"font-16 font-bold text-muted") : cx(css`color: #4CAF50`,"font-16 font-bold")}>+ {formatCurrency(data?.tenant?.property?.currency, data?.amount)}</h4> : 
              <h4 className={data.cancel ? cx(css`text-decoration: line-through`,"font-16 font-bold text-muted") : cx(css`color: #F44336`,"font-16 font-bold")}>- {formatCurrency(data?.tenant?.property?.currency, data?.amount)}</h4>
            }
            {
              data?.cancel &&
              <h4 className='font-16 font-bold text-primary'>0</h4>
            }
          </div>
        </div>
      </div>
    </div>
  );
});

const PanelLoading = React.memo(({ id, width }) => {
  return (
    <StyledTableRow>
      <StyledTableCell width="5%">
        <Skeleton
          variant="text"
          animation="wave"
          width={width === "sm" || width === "xs" || width === "md" ? 40 : 60}
        />
      </StyledTableCell>
      <StyledTableCell>
        <Skeleton
          variant="text"
          animation="wave"
          width={width === "sm" || width === "xs" || width === "md" ? 80 : 100}
        />
      </StyledTableCell>
      <StyledTableCell>
        <Skeleton
          variant="text"
          animation="wave"
          width={width === "sm" || width === "xs" || width === "md" ? 80 : 100}
        />
      </StyledTableCell>
      <StyledTableCell>
        <Skeleton
          variant="text"
          animation="wave"
          width={width === "sm" || width === "xs" || width === "md" ? 80 : 100}
        />
      </StyledTableCell>
      <StyledTableCell>
        <Skeleton
          variant="text"
          animation="wave"
          width={width === "sm" || width === "xs" || width === "md" ? 80 : 100}
        />
      </StyledTableCell>
    </StyledTableRow>
  );
});
const PanelTransaksiLoading = React.memo(({ id, width }) => {
  const classes = useStyles();
  return (
    <div className="py-3 bg-white border-bottom-2-secondary" key={id}>
      <div className="w-100 d-flex justify-content-start align-items-start">
        <Skeleton variant="rect" animation="wave" width={40} height={40} />
        <div className={cx(css`width: 65% !important`,"pl-4 pr-3")}>
            <span className="font-14 font-bold text-primary">
              <Skeleton valiant="text" animation="wave" />
            </span>
          
          <p className="font-12 text-primary mt-3">
            <Skeleton valiant="text" animation="wave" />
            <Skeleton valiant="text" animation="wave" width="80%" />
          </p>
        </div>
        <div className="ml-auto">
          <div className="d-flex flex-column justify-content-start align-items-end">
            <span className="text-muted font-9">
              <Skeleton valiant="text" animation="wave" width={120} />
            </span>
            <h4 className="font-16 font-bold">
              <Skeleton valiant="text" animation="wave" width={100} />
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
});
const ListPanel = withWidth()(Panel);
const ListTransaksi = withWidth()(PanelTransaksi);
const ListPanelLoading = withWidth()(PanelLoading);
const ListTransaksiLoading = withWidth()(PanelTransaksiLoading);
export { ListPanel, ListPanelLoading, ListTransaksi, ListTransaksiLoading };
